export default {"src":"__ASTRO_ASSET_IMAGE__CNmjo73f__","width":256,"height":181,"format":"webp"}